import { MdPersonAddAlt1 } from "react-icons/md";
import AddButton from "../../components/buttons/AddButton";
import Dashboard from "../../components/Dashboard";
import Table, { Badge } from "../../components/Table";
import {
  clinicalScientistTableHeadData,
  // getClinicalScientistTableData,
} from "../../constants/data/clinicalScientist";
import { useEffect, useState } from "react";
import Clinicical from "../../components/Modals/Clinicical";
import { useModal } from "../../context/modalContext";
import { useSelector } from "react-redux";
import { Spinner } from "@material-tailwind/react";
import { HttpClient } from "../../Redux/controllers/HttpClient";
import { useForm } from "../../context/formContext";
import AddClinicalScientist from "./../../components/forms/AddClinicalScientist";
import Edit from "../../components/buttons/Edit";
import Delete from "../../components/buttons/DeleteButton";
import DeleteUserModal from "../../components/Modals/DeleteUserModal";

const ClinicalScientist = () => {
  const {
    showEditModal,
    showModal,
    openModal,
    closeModal,
    closeEditModal,
    openDeleteModal,
    closeDeleteModal,
    showDeleteModal,
  } = useModal();
  const { showForm, openForm, closeForm } = useForm();

  const [showSpin, setShowSpin] = useState(false);
  const { token } = useSelector((state) => state.user);
  const [clinicalScientistTableData, setClinicalScientistTableData] = useState(
    []
  );
  useEffect(() => {
    const fetchData = async () => {
      setShowSpin(true);
      try {
        const { data } = await HttpClient.apiCaller(
          "admin/user-list?role=scientist",
          "GET",
          null,
          token,
          null
        );
        console.log(data.user);
        setClinicalScientistTableData(data.user);
      } catch (error) {
        console.log(error);
      } finally {
        setShowSpin(false);
      }
    };

    fetchData();

    return () => {};
  }, [closeModal, closeForm]);
  const getClinicalScientistTableData = (dataSet) => {
    const tableData = dataSet?.map((item, idx) => {
      return {
        no: idx + 1,
        uid: item?.uid,
        firstName: item?.first_name || "N/A",
        lastName: item?.last_name || "N/A",
        email: item?.email || "N/A",
        // status: <Badge status={item?.status} />,
        action: (
          <div className="flex gap-3">
            <Edit user={item} />
            <Delete user={item} />
          </div>
        ),
      };
    });
    return tableData;
  };
  return (
    <Dashboard>
      {showForm ? (
        <AddClinicalScientist onClose={closeForm} />
      ) : (
        <>
          <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5">
            <div>
              <p className="poppins-medium  leading-[21px]  text-gray-700 mb-2">
                List of Clinical Scientists
              </p>
              <p className="poppins-regular text-xs text-[#B5B5C3] ">
                {clinicalScientistTableData?.length} available clinical
                scientists
              </p>
            </div>
            {/*  */}
            <AddButton
              onClick={openForm}
              buttonName={"Add New Clinical Scientist"}
              icon={<MdPersonAddAlt1 className="size-5" />}
            />
          </div>
          {/*  table */}
          {showSpin ? (
            <div className="w-full mt-20 flex items-center justify-center">
              <Spinner className="h-12 w-12" />{" "}
            </div>
          ) : (
            <Table
              tableData={getClinicalScientistTableData(
                clinicalScientistTableData
              )}
              tableHeadData={clinicalScientistTableHeadData}
            />
          )}

          {/* {showModal ? <Clinicical onClose={closeModal} edit={false} /> : <></>} */}

          {showEditModal ? (
            <Clinicical edit={true} onClose={closeEditModal} />
          ) : (
            <></>
          )}
        </>
      )}
      {/* delete modal */}
      {showDeleteModal && <DeleteUserModal onClose={closeDeleteModal} />}
    </Dashboard>
  );
};

export default ClinicalScientist;
